import { apiClient } from "./client";

export async function login(username, password) {
  const res = await apiClient.post("/v1/auth/", {
    username: username.trim().toLowerCase(),
    password,
  });
  return res.data?.data || res.data;
}
